<template>
  <div>
    <modal
      title=" Edit Service"
      name="editServices"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <validation-observer ref="observer">
            <form @submit.prevent class="create-service mb-base">
              <Select
                label="Service Head"
                :style="
                  editDetails === 'charge'
                    ? 'pointer-events: none; opacity: 60%;'
                    : ''
                "
                :options="servicesList"
                :value="service.serviceHead"
                styles="mb-base"
                :input="handleServices"
                :clearable="false"
                :is-disabled="true"
              />
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  :style="
                    editDetails === 'charge'
                      ? 'pointer-events: none; opacity: 60%;'
                      : ''
                  "
                  class="mb-base"
                  label="Service Name"
                  type="text"
                  :error="errors[0]"
                  v-model="service.name"
                />
              </validation-provider>
              <!-- <validation-provider rules="required"> -->
              <Select
                class="mb-base type-select"
                :style="
                  editDetails === 'charge'
                    ? 'pointer-events: none; opacity: 60%;'
                    : ''
                "
                label="Select Branch"
                :input="val => (service.branchId = val.key)"
                :clearable="false"
                :placeholder="
                  currentSelectedBranch.key === 1
                    ? 'Head Office Branch'
                    : 'Islamabad Branch'
                "
                :options="brachData"
                required
              />
              <!-- </validation-provider> -->
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  v-if="editDetails === 'charge'"
                  class="mb-base"
                  label="Amount"
                  type="number"
                  :error="errors[0]"
                  v-model="chargePayload.amount"
                />
              </validation-provider>
              <Button
                className="button--primary custom-button"
                title="Update"
                :onClick="handleUpdate"
                :loader="loading"
              ></Button>
            </form>
          </validation-observer>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Select from "@/components/Select";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Select,
    Button,
    Modal,
    Input
  },
  props: {
    servicesList: {
      type: Array
    },
    currentSelectedBranch: {
      default: {
        key: 1
      }
    },
    editDetails: {
      type: String
    }
  },
  data() {
    return {
      brachData: [],
      serviceHead: "",
      service: {},
      chargePayload: {},
      chargeId: "",
      placehollder: "",
      organizationType: [
        { id: "familyhealth", for: "familyhealth", label: "FHH" },
        { id: "medirad", for: "medirad", label: "MEDI RAD" }
      ]
    };
  },
  methods: {
    ...mapActions("services", [
      "updateService",
      "updateCharge",
      "chargeDetail",
      "filterServices"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    handleUpdate() {
      if (this.editDetails == "service") {
        this.$refs.observer.validate().then(() => {
          this.service.branchId = this.currentSelectedBranch?.key;
          this.updateService({
            id: this.detailsService.serviceId,
            payload: this.service
          })
            .then(() => {
              this.$modal.hide("editServices");
              // this.$toasted
              //   .success("Service updated successfully")
              //   .goAway("3000");
            })
            .catch(() => {
              this.$toasted.success("Failed").goAway("3000");
            });
        });
      } else {
        this.$refs.observer.validate().then(success => {
          this.chargePayload.branchId = this.currentSelectedBranch?.key;
          if (!success) {
            return;
          }
          this.updateCharge({
            id: this.chargeId,
            payload: this.chargePayload
          })
            .then(() => {
              this.$modal.hide("editServices");
              // this.$toasted
              //   .success("Service updated successfully")
              //   .goAway("3000");
              const query = {
                branch: this.chargePayload.branchId,
                other: 0
              };
              this.filterServices(query);
            })
            .catch(() => {
              this.$toasted.success("Failed").goAway("3000");
            });
        });
      }
    },
    handleServices(val) {
      this.service.serviceHead = val.name;
      this.service.lookupId = val.id;
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      detailsService: "services/detailsService",
      fetchUserBranch: "expenses/fetchUserBranch"
    })
  },
  watch: {
    detailsService(val) {
      if (this.editDetails == "service") {
        this.service = {
          name: val?.service?.name,
          serviceHead: val?.service?.lookup?.name
        };
      } else {
        this.chargeId = val.id;
        this.service = {
          amount: val?.amount,
          name: val?.service?.name,
          serviceHead: val?.service?.lookup?.name
        };
        this.chargePayload = {
          serviceId: val.service.id,
          amount: val?.amount
        };
      }
    }
  },
  async mounted() {
    await this.fetchBranch();
    await this.fetchUserBranch?.map(elem => {
      this.brachData?.push({ name: elem.name, key: elem.id });
    });
  }
};
</script>

<style scoped>
/* ── Services edit modal ───────────────────────────────────── */
.create-service {
  display: flex;
  flex-direction: column;
}

/* Full-width submit inside modal forms */
.custom-button {
  width: 100%;
  margin-top: 4px;
}
</style>
